export enum EFeatureRoutes {
  TERMS               = 'terms',
  SHOP_CART           = 'shop-cart',
  MY_INSTALLED_BASE   = 'my-installed-base',
  EQUIPMENT_SELECTION = 'equipment-selection',
  CHECKOUT            = 'checkout',
  CHECKOUT_REVISION   = 'checkout-revision',
  PURCHASE_ACTIVITY   = 'purchase-activity',
  MY_PROFILE          = 'my-profile',
  CATALOG             = 'catalog',
  WISHLISTS           = 'wishlists',
  MAINTENANCE         = 'maintenance',
  ERROR               = 'error',
  CONTACT_US          = 'contact-us',
}
